/**
 * ImageDescriptionsFeature - Show alt text overlays on images
 */
import BaseFeature from './BaseFeature.js';

export default class ImageDescriptionsFeature extends BaseFeature {
    constructor(widget, options = {}) {
        super(widget, options);
        this._overlays = [];
    }

    enable() {
        super.enable();
        this._createOverlays();
        this.addBodyClass('dhA11y-image-descriptions');
    }

    disable() {
        super.disable();
        this._removeOverlays();
        this.removeBodyClass('dhA11y-image-descriptions');
    }

    /**
     * Create alt text overlays on all images
     */
    _createOverlays() {
        const images = document.querySelectorAll('img[alt]');
        images.forEach(img => {
            const alt = img.getAttribute('alt');
            if (!alt || alt.trim().length === 0) return;

            // Make parent relative if needed
            const parent = img.parentElement;
            const parentPos = window.getComputedStyle(parent).position;
            if (parentPos === 'static') {
                parent.style.position = 'relative';
                parent.dataset.a11yPositionChanged = 'true';
            }

            const overlay = document.createElement('div');
            overlay.className = 'dhA11y-image-desc-overlay';
            overlay.textContent = alt;
            overlay.setAttribute('aria-hidden', 'true');

            parent.appendChild(overlay);
            this._overlays.push({ overlay, parent });
        });
    }

    /**
     * Remove all overlays
     */
    _removeOverlays() {
        this._overlays.forEach(({ overlay, parent }) => {
            overlay.remove();
            if (parent.dataset.a11yPositionChanged) {
                parent.style.position = '';
                delete parent.dataset.a11yPositionChanged;
            }
        });
        this._overlays = [];
    }
}
